/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventalreadycancellederror3Inputs */

const en_eventalreadycancellederror3 = /** @type {(inputs: Eventalreadycancellederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This event has already been canceled.`)
};

const de_eventalreadycancellederror3 = /** @type {(inputs: Eventalreadycancellederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Event wurde schon abgesagt.`)
};

/**
* | output |
* | --- |
* | "This event has already been canceled." |
*
* @param {Eventalreadycancellederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventalreadycancellederror3 = /** @type {((inputs?: Eventalreadycancellederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventalreadycancellederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventalreadycancellederror3(inputs)
	return de_eventalreadycancellederror3(inputs)
});
export { eventalreadycancellederror3 as "eventAlreadyCancelledError" }